import { media } from 'styled-bootstrap-grid';
import PureDatePicker from 'react-datepicker';
import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 24px;

  h3 {
    font-weight: 600;
    font-size: 15px;
  }

  ${media.md`
    justify-content: space-between;
    h3 {
      font-size: 16px;
    }
  `};
`;

export const MonthName = styled.span`
  font-family: ${({ theme }) => theme.bodyFont};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  font-size: 16px;
  padding-right: 30px;
`;

export const StyledPicker = styled(PureDatePicker)`
  width: 100%;
  margin: 0;
  float: right;
  display: block;
  font-size: 25px;
  padding: 14px;
  outline: none;

  &::placeholder {
    color: #776969;
    font-style: italic;
  }
`;

export const StyledMobileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;

  .SingleDatePickerInput {
    padding-left: 10px;
    border-color: transparent;
  }

  .DayPickerNavigation {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
  }
  .SingleDatePicker {
    height: 0;
  }
  .SingleDatePicker_picker {
    display: flex;
    justify-content: center;
    top: 20px !important;
    width: 100%;
    background-color: transparent;
  }

  .DayPicker__withBorder {
    box-shadow: none;
    border-color: transparent;
  }

  .DayPicker__hidden {
    visibility: visible;
  }

  .DayPicker {
    position: relative;
    display: flex;
    height: 100%;
    justify-content: center;
    padding-top: 0px !important;
    border: 1px solid black;

    * {
      border-color: transparent !important;
    }

    .DayPicker_weekHeader {
      top: 50px;
    }

    .CalendarMonth_caption {
      padding-top: 0px;
    }

    .DayPicker_focusRegion {
      width: 100%;
    }
  }

  .DateInput {
    display: none;
  }
`;
